import * as DictionaryConstants from '../../../../../../constants/DictionaryConstants'
import * as RoutePathConstants from '../../../../../../constants/RoutePathConstants'
import { API_BASE_URL } from '../../../../../../common/utils/commonUrl'
import http from '../../../../../../common/utils/http'
import { DOWNLOAD_FILE, UPLOAD_FILE } from '../../../../../../common/utils/uploadFileUtil'
import moment from 'moment'

export default {
  data () {
    return {
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now()
        }
      },
      options: [
        {
          value: '09:00:00',
          label: '09:00:00'
        }, {
          value: '10:00:00',
          label: '10:00:00'
        }, {
          value: '11:00:00',
          label: '11:00:00'
        }, {
          value: '12:00:00',
          label: '12:00:00'
        }, {
          value: '13:00:00',
          label: '13:00:00'
        }, {
          value: '14:00:00',
          label: '14:00:00'
        }, {
          value: '15:00:00',
          label: '15:00:00'
        }, {
          value: '16:00:00',
          label: '16:00:00'
        }, {
          value: '17:00:00',
          label: '17:00:00'
        }],
      memberInfoForm: {
        time: '',
        date: '',
        reservationType: '',  //维修类别  1000是保养  2000是维修  3000是检测
        reservationTime: '',  //预约时间
        mileage: '', //当前公里数
        remarks: '',  //备注
        memberCarId: '',
        codeToFileIds: {
          categoryIcon: []
        } //图片  
      },
      carNumberList: [],
      assessImageList2: [],
      detailsForm: {
        companyName: '',
        address: '',
        reservationPhone: '',
        rescuePhone: '',
        codeToFileIds: {
          logo: []
        }, //图片          
      },
      actionUrl: UPLOAD_FILE, //上传图片
      assessImageList: [],//上传图片
      dialogImageUrl: '',//上传图片
    }
  },
  methods: {
    async submit () {
      this.$refs['memberForm'].validate(async (valid) => {
        if (valid) {
          if (this.memberInfoForm.date == "") {
            this.$message.warning('请选择预约日期!')
            return
          };
          if (this.memberInfoForm.time == "") {
            this.$message.warning('请选择预约时间!')
            return
          };
          if (this.memberInfoForm.mileage) {
            if (!/^\d+$/.test(this.memberInfoForm.mileage)) {
              this.$message.warning('当前公里数请输入正整数!')
              return
            };
          };
          this.memberInfoForm.reservationTimeString = this.memberInfoForm.date + ' ' + this.memberInfoForm.time
          http.post(API_BASE_URL + '/api/wxoa/member/member/addMemberReservationInfo2', this.memberInfoForm)
            .then(
              res => {
                this.$message.success('预约成功!')
                setTimeout(this.$router.push({
                  path: '/wxmember/personalCenter'
                }), 3000)
              }
            )
            .catch(
              err => {
                this.$message.error(err.data.message);
              }
            )
        }
      })

    },
    getCompanyInfo () {
      http.get(API_BASE_URL + '/api/sys/prop/typeId/100/propName/companyInfo').then(
        res => {
          const id = res.data.data.id
          const info = res.data.data.value
          const codeToFileIds = info.codeToFileIds || {}
          codeToFileIds.logo = codeToFileIds.logo || []
          this.id = id
          this.detailsForm = {
            companyName: info.companyName,
            address: info.address,
            reservationPhone: info.reservationPhone,
            rescuePhone: info.rescuePhone,
            codeToFileIds: codeToFileIds
          }

          if (codeToFileIds && codeToFileIds.logo) {
            this.assessImageList2 = []
            let fileIds = codeToFileIds.logo
            this.fileIdList = fileIds
            fileIds.forEach((item, index) => {
              this.assessImageList2.push({
                name: item,
                uid: index,
                url: `${DOWNLOAD_FILE}${item}`
              })
            })
          }
        }
      )
    },
    getMemberDetails () {
      http
        .get(`${API_BASE_URL}/api/wxoa/member/member/getUserMemberDetails`)
        .then(res => {
          this.carNumberList = res.data.data.memberCarDTOList;
        });
    },
    // 上传图片
    beforeUpload (file) {
      const imgTypes = ['jpg', 'png']
      const fileSplitList = file.name.split('.')
      const fileSuffix = fileSplitList[fileSplitList.length - 1]
      if (!imgTypes.includes(fileSuffix)) {
        this.$message.error('只能上传图片')
        return false
      } else {
        return true
      }

    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    successFile (response, file, fileList) {
      this.memberInfoForm.codeToFileIds.categoryIcon.push(response.data.fileId)
    },
    handleRemove (file, fileList) {
      console.log(this.memberInfoForm.codeToFileIds.categoryIcon, 'sss')

      // 如果用户上传图片之后不想要了，删除图片，那么同时也要删除集合中已上传成功的文件
      const addFileIndex = this.memberInfoForm.codeToFileIds.categoryIcon.findIndex(item => item === file.response ? file.response.data.fileId : file.name)
      if (addFileIndex !== -1) {
        this.memberInfoForm.codeToFileIds.categoryIcon.splice(addFileIndex, 1)
      }
    },
    beforeRemove (file, fileList) {
      return this.$confirm(`确定移除该图片吗？`)
    },
  },
  mounted () {
    this.memberInfoForm.reservationType = this.$route.query.reservationType
    switch (this.memberInfoForm.reservationType) {
      case 1000:
        document.title = '保养预约'
        break
      case 2000:
        document.title = '维修预约'
        break
      case 3000:
        document.title = '检测预约'
        break

    }
    this.getCompanyInfo()
    this.getMemberDetails()
  },
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/points-mail-home-page-new/views/make-an-appointment/make-an-appointment.js